// extracted by mini-css-extract-plugin
export default {"deviceIcon":"styles_deviceIcon__7n8AG","deviceIconImage":"styles_deviceIconImage__zmmMv","status":"styles_status__XvM4w","read":"styles_read__9UUR0"};